export const getProductBasePrice = (product) =>
  Number(product?.PrecioOferta) > 0
    ? Number(product.PrecioOferta)
    : Number(product?.PrecioLista) || 0;

export const getQuantityDiscount = (product, quantity = 1) => {
  const discounts = product?.productos_desc_x_cant || product?.prod_desc_x_cant || [];
  const qty = Number(quantity) || 1;

  if (!Array.isArray(discounts) || discounts.length === 0) {
    return {
      porcentaje: 0,
      importeUnitario: 0,
      regla: null,
    };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const applicable = discounts
    .map((discount) => ({
      ...discount,
      cantidad_desde: Number(discount.cantidad_desde ?? discount.cantidad) || 0,
      descuento: Number(discount.descuento) || 0,
    }))
    .filter((discount) => {
      const dateValue = discount.fecha_hasta;
      const isActiveByDate = !dateValue || Number.isNaN(new Date(dateValue).getTime()) || new Date(dateValue) >= today;
      return discount.cantidad_desde > 0 && discount.descuento > 0 && qty >= discount.cantidad_desde && isActiveByDate;
    })
    .sort((a, b) => b.cantidad_desde - a.cantidad_desde);

  const regla = applicable[0] || null;
  const porcentaje = regla?.descuento || 0;
  const basePrice = getProductBasePrice(product);

  return {
    porcentaje,
    importeUnitario: basePrice * (porcentaje / 100),
    regla,
  };
};

export const getDiscountedUnitPrice = (product, quantity = 1) => {
  const basePrice = getProductBasePrice(product);
  const { porcentaje } = getQuantityDiscount(product, quantity);
  return basePrice * (1 - porcentaje / 100);
};
